import { Tuple2 } from './tuple2.model';

export class BuergschaftsAntragType {

    // Immer befristet wird nirgends verwendet, ist aber implementiert
    constructor(
        public buergschaftsart: string,
        public label: string,
        public formulare: Tuple2<string, string>[],
        public immerBefristet: boolean = false
    ) {
    }

}

/**
 * Fachliche Dokumentation hierzu im Confluence: https://confluence.ads.vhv.de/pages/viewpage.action?pageId=96576586
 */
export class BuergschaftsAntragTypes {

    static formularVhv: Tuple2<string, string> = new Tuple2('NEIN', 'Formular der VHV');
    static formularVhvBauhandwerker: Tuple2<string, string> = new Tuple2('SF01', 'Formular der VHV'); // Bauhandwerkersicherung
    static formularVhvVorauszahlung: Tuple2<string, string> = new Tuple2('VO30', 'Formular der VHV'); // Vorauszahlung
    // Achtung: Vorauszahlung/VO30 ist nur für unbefristete BS Kürzel VO30 und wird bei Befristung vom Backend auf VO31 umgemappt

    static formularAuftraggeber: Tuple2<string, string> = new Tuple2('SF00', 'Formular des Auftraggebers');

    static formularHVA_Maengelansprueche: Tuple2<string, string> = new Tuple2('ST20', 'HVA B-StB-Mängelansprüche');
    static formularHVA_Vertragserfuellung: Tuple2<string, string> = new Tuple2('ST10', 'HVA B-StB-Vertragserfüllung');
    static formularHVA_Vorauszahlung: Tuple2<string, string> = new Tuple2('AG03', 'HVA B-StB-Vorauszahlung');

    static formularEFB_SICH1: Tuple2<string, string> = new Tuple2('EF13', 'Formular EFB Sich 1');
    static formularEFB_SICH2: Tuple2<string, string> = new Tuple2('EF21', 'Formular EFB Sich 2');
    static formularEFB_SICH3: Tuple2<string, string> = new Tuple2('AG38', 'Formular EFB Sich 3');

    static formularKEV310_SICH1: Tuple2<string, string> = new Tuple2('KF12', 'Formular KEV 310 Sich 1');
    static formularKEV311_SICH2: Tuple2<string, string> = new Tuple2('KF23', 'Formular KEV 311 Sich 2');
    static formularKEV312_SICH3: Tuple2<string, string> = new Tuple2('KF10', 'Formular KEV 312 Sich 3');

    static formulare: Tuple2<string, string>[] = [
        BuergschaftsAntragTypes.formularVhv,
        BuergschaftsAntragTypes.formularVhvBauhandwerker,
        BuergschaftsAntragTypes.formularVhvVorauszahlung,
        BuergschaftsAntragTypes.formularAuftraggeber,
        BuergschaftsAntragTypes.formularHVA_Maengelansprueche,
        BuergschaftsAntragTypes.formularHVA_Vertragserfuellung,
        BuergschaftsAntragTypes.formularHVA_Vorauszahlung,
        BuergschaftsAntragTypes.formularEFB_SICH1,
        BuergschaftsAntragTypes.formularEFB_SICH2,
        BuergschaftsAntragTypes.formularEFB_SICH3,
        BuergschaftsAntragTypes.formularKEV310_SICH1,
        BuergschaftsAntragTypes.formularKEV311_SICH2,
        BuergschaftsAntragTypes.formularKEV312_SICH3,
    ];

    static types: BuergschaftsAntragType[] = [
        new BuergschaftsAntragType(
            'AF',
            'Ausführungsbürgschaft',
            [
                BuergschaftsAntragTypes.formularVhv,
                BuergschaftsAntragTypes.formularAuftraggeber
            ]
        ),
        new BuergschaftsAntragType(
            'VE',
            'Vertragserfüllungsbürgschaft',
            [
                BuergschaftsAntragTypes.formularVhv,
                BuergschaftsAntragTypes.formularKEV310_SICH1,
                BuergschaftsAntragTypes.formularEFB_SICH1,
                BuergschaftsAntragTypes.formularHVA_Vertragserfuellung,
                BuergschaftsAntragTypes.formularAuftraggeber
            ]
        ),
        new BuergschaftsAntragType(
            'MA',
            'Mängelansprüchebürgschaft (Gewährleistungsbürgschaft)',
            [
                BuergschaftsAntragTypes.formularVhv,
                BuergschaftsAntragTypes.formularEFB_SICH2,
                BuergschaftsAntragTypes.formularKEV311_SICH2,
                BuergschaftsAntragTypes.formularHVA_Maengelansprueche,
                BuergschaftsAntragTypes.formularAuftraggeber
            ]
        ),
        new BuergschaftsAntragType(
            'BI',
            'Bietungsbürgschaft',
            [
                BuergschaftsAntragTypes.formularVhv,
                BuergschaftsAntragTypes.formularAuftraggeber
            ]
        ),
        new BuergschaftsAntragType(
            'BS',
            'Bauhandwerkersicherungbürgschaft (gem. § 650f BGB)',
            [
                BuergschaftsAntragTypes.formularVhvBauhandwerker,
                BuergschaftsAntragTypes.formularAuftraggeber
            ]
        ),
        new BuergschaftsAntragType(
            'VA',
            'Vorauszahlungsbürgschaft',
            [
                BuergschaftsAntragTypes.formularVhvVorauszahlung,
                BuergschaftsAntragTypes.formularEFB_SICH3,
                BuergschaftsAntragTypes.formularKEV312_SICH3,
                BuergschaftsAntragTypes.formularHVA_Vorauszahlung,
                BuergschaftsAntragTypes.formularAuftraggeber,
            ]
        )
    ];

    static findByBuergschaftsart(buergschaftsart: string): BuergschaftsAntragType {
        const buergschaftsAntragType = BuergschaftsAntragTypes.types.find(b => b.buergschaftsart === buergschaftsart);

        if (buergschaftsAntragType) {
            return buergschaftsAntragType;
        }

        return new BuergschaftsAntragType(
            'SO',
            'Sonstige Bürgschaftsart',
            [BuergschaftsAntragTypes.formularVhv]
        );
    }

    static findByFormularKuerzel(formularKuerzel: string): Tuple2<string, string> {
        return BuergschaftsAntragTypes.formulare.find(formular => formular.left === formularKuerzel);
    }

}
